import React from 'react'
import { Icon } from '@st-operations/uikit/src/v2'
import classNames from 'classnames'

import { UIKIT_COLORS } from '../../pages/event-feeds/visualization-panel/scale-and-coverage/constants'

import './styles.scss'

const ListSelectionItem = ({ number, children, selected, onClick }) => {
  return (
    <div
      className={classNames('list-selection-item', { 'list-selection-item--selected': selected })}
      onClick={onClick}
    >
      <span className="list-selection-item__number">{number}.</span>
      <span className="list-selection-item__label">{children}</span>
      <Icon type="outline" icon="angleright" color={UIKIT_COLORS.ds_green} />
    </div>
  )
}

export default ListSelectionItem
